import { render, staticRenderFns } from "./Plugins.vue?vue&type=template&id=59c5ff3a&scoped=true&"
import script from "./Plugins.vue?vue&type=script&lang=jsx&"
export * from "./Plugins.vue?vue&type=script&lang=jsx&"
import style0 from "./Plugins.vue?vue&type=style&index=0&id=59c5ff3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5ff3a",
  null
  
)

export default component.exports